import { CommonModule } from '@angular/common';
import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';

@Directive({
    standalone: true,
    selector: 'img[altSrc]'
})
export class AltSrcDirective implements AfterViewInit {
    @Input() altSrc: string[];

    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        const imgElement = this.el.nativeElement;

        const errorHandler = () => {
            if (this.altSrc.length === 0) {
                imgElement.removeEventListener('error', errorHandler);
                return;
            }
            let nextImg = this.altSrc.shift();
            imgElement.src = nextImg;
        };

        imgElement.addEventListener('error', errorHandler);
    }
}
